/*
 * FB-1522: hide a product card award logo that fails to load.
 *
 * Award logos are rendered server-side by snippets/custom-product-awards.liquid.
 * A broken one is hidden rather than left as a broken-image box, and a card
 * whose logos all failed gives the text badge row its full width back.
 *
 * `error` does not bubble, so it is caught on `document` in the capture phase,
 * which also covers cards added later (recommendations, ajax grids). Logos that
 * failed before this deferred script ran are found by the initial sweep.
 */
(() => {
  const IMG = '.fb-awards__img';

  const hideAward = (img) => {
    const item = img.closest('.fb-awards__item');
    if (!item || item.hidden) return;
    item.hidden = true;

    const list = item.closest('.fb-awards');
    if (list && !list.querySelector('.fb-awards__item:not([hidden])')) {
      list.hidden = true;
      list.parentElement?.classList.remove('fb-has-awards');
    }
  };

  document.addEventListener(
    'error',
    (event) => {
      const target = event.target;
      if (target instanceof HTMLImageElement && target.matches(IMG)) hideAward(target);
    },
    true
  );

  document.querySelectorAll(IMG).forEach((img) => {
    if (img.complete && img.naturalWidth === 0 && img.currentSrc) hideAward(img);
  });
})();
